export default __webpack_public_path__ + "static/media/bigl-black.dbaded9d.svg";